import { Button } from 'antd';
import React from 'react'
import ReactExport from "react-export-excel";
import { DownloadOutlined  } from '@ant-design/icons';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcel({data}) {
    console.log({data})
   return (

       
        <ExcelFile filename="Resumes" element={<Button icon={<DownloadOutlined/>} className="mx-2" type="primary" style={{fontSize: '14px'}}>Download</Button>}>
                
        <ExcelSheet data={data} name="Resumes" >
            <ExcelColumn label="Name" value={col => col?.name ? col.name: "null"}/> 
            <ExcelColumn label="Last Name" value={col => col?.last_name ? col.last_name: "null"}/> 
            <ExcelColumn label="Phone Number" value={col => col?.phone_number ? col.phone_number: "null"}/> 
            <ExcelColumn label="Email" value={col => col?.email ? col.email: "null"}/> 

            <ExcelColumn label="Department Appplied For" value={col => col?.department ? col.department: "null"}/> 
            <ExcelColumn label="Post Applied For" value={col => col?.post_applying_for ? col.post_applying_for: "null"}/> 
            {/* <ExcelColumn label="Resume" value={col => col?.resume ? col.resume: "null"}/>  */}
        </ExcelSheet>
    </ExcelFile>
    )
}